// extracted by mini-css-extract-plugin
export default {"container":"filter-label_container__wlb3z","truncate-table":"filter-label_truncate-table__SfmKP","table-text-faded":"filter-label_table-text-faded__jU6rk","filterLabel":"filter-label_filterLabel__zVQep","labelTitle":"filter-label_labelTitle__E+Ca2","label":"filter-label_label__Xdx9U","labelText":"filter-label_labelText__E4BQB","withIcon":"filter-label_withIcon__vT4qz"};
    if(module.hot) {
      // 1792500653323
      var cssReload = require("!../../../../../node_modules/.pnpm/css-hot-loader@1.4.4/node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  